import { CLEAN_REG_EXP, REG_EXP } from './config/index.js'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Spinner from '../Spinner/Spinner'
import get from 'lodash-es/get'
import replace from 'lodash-es/replace'

class FieldSet { }

export const html = PropTypes.html

export const parser = (data = {}, text, reg) => {
  return replace(text, reg, (chunk) => {
    const parsed = get(data, chunk.match(CLEAN_REG_EXP)[0])
    return ['string', 'number', 'boolean'].includes(typeof parsed) ? parsed : ''
  })
}

/**
 * RAW html
 */
export default class Html extends Component {
  static propTypes = {
    /**
     * Allows you to edit HTML.
     */
    html: html,
    /**
     * List of data/records.
     */
    record: PropTypes.object,
    /**
     * Fields to be displayed in HTML component.
     */
    fieldset: PropTypes.arrayOf(PropTypes.instanceOf(FieldSet)),
    /**
     * Spinner to show when the component is loading.
     */
    isLoading: PropTypes.bool.isRequired,
    /**
     * Allows you to hide the Toolbar.
     */
    hideToolbar: PropTypes.bool
  }
  static defaultProps = {
    isLoading: false,
    hideToolbar: false

  }
  render () {
    const { html, record, isLoading } = this.props
    const data = (record && record.filter && record.filter(f => f)[0]) || record || {}
    const finalData = data && data.constructor === {}.constructor && JSON.parse(JSON.stringify(data))
    const innerHtml = (html && parser(finalData, html, REG_EXP)) || ''
    const loadingStyle = isLoading ? { height: '100%', display: 'flex', justifyContent: 'center' } : {}
    return (
      <div style={loadingStyle} onClick={this.props.onClick}>
        {isLoading
          ? <Spinner isVisible={isLoading} size='small' />
          : <div dangerouslySetInnerHTML={{ __html: innerHtml }} />}
      </div>
    )
  }
}
